const common = {
  // Existing keys
  Pricing: 'Pricing',
  Calculator: 'Calculator',
  Promotion: 'Promotion',
  Schedule: 'Schedule',
  'Get Started': 'Get Started',
  'Manage Spacecraft': 'Manage Spacecraft',
  'Contact Profile': 'Contact Profile',
  'Schedule a Contact': 'Schedule a Contact',
  'Manage Contacts': 'Manage Contacts',
  Support: 'Support',
  FAQ: 'FAQ',
  'Contact Us': 'Contact Us',
  'SpaceTime Tools': 'SpaceTime Tools',
  'Commanding':'Commanding',

  // Added keys
  Home: 'Home',
  Dashboard: 'Dashboard',
  Admin: 'Admin',
  'Manage User': 'Manage User',
  'Manage Ground Station': 'Manage Ground Station',
  'Manage S3': 'Manage S3',
  'Manage Schedule': 'Manage Schedule',
  'Manage Payment': 'Manage Payment',
  'Manage Mail': 'Manage Mail',
  'Manage Inquiry': 'Manage Inquiry',
  'Manage Promotion': 'Manage Promotion'
};

const spacetimeTools = {
  pageTitle: 'SpaceTime Tools',
  description: 'Simple and accurate tools for converting time, coordinates, and satellite TLE data.',
  tabs: {
    timeConversion: 'Time Conversion',
    coordinateTransformation: 'Coordinate Transformation',
    tleDataConverter: 'TLE Data Converter'
  }
};

export { spacetimeTools };
export default common;
